import React from "react";
import { observer } from "mobx-react";
import { observable } from "mobx";
import { vms_list, permission_list, vms_list_original } from "../userData.js";
import { open_vm } from "../useRDP.js";
import { LoadingScreen } from "./LoadingScreen";
import { VMStatus } from './VMStatus';
import { Latency } from "@v2cloud/telemetry";
import { openZendeskChat } from "../zendesk.js";


const loading = observable.box(false);

const splashPermissionsForVM = (id) =>

  Object.entries(permission_list.get())

    .filter(([_, permission]) => {
      const vm = permission && permission.vm;
      if(!vm || typeof vm.id === 'undefined') return false;

      return String(vm.id) === String(id);
    })

    // Permission list is already scoped to the logged-in user by API calls.
    // Avoid extra user filtering so pool cards are never dropped intermittently.
    ;

const displayPermissionsForVM = (id, is_vmpool) => {
  const permissions = splashPermissionsForVM(id);

  if(!is_vmpool) return permissions;

  // Pool sections should expose a single connect card that goes through
  // the pool permission (least-load selection), not a specific backing VM.
  const desktop_pool_permission = permissions.find(([_, permission]) =>
    permission && permission.type === 'vmpool'
  );

  if(desktop_pool_permission) return [desktop_pool_permission];

  return permissions.length ? [permissions[0]] : [];
};

const getSplashVMs = () =>
  Object.values(vms_list.get()).sort((a, b) => {
    const a_is_pool = !!(a && a.is_vmpool);
    const b_is_pool = !!(b && b.is_vmpool);

    if(a_is_pool !== b_is_pool) return a_is_pool ? -1 : 1;

    const a_name = (a && a.descriptor) || '';
    const b_name = (b && b.descriptor) || '';
    return a_name.localeCompare(b_name);
  });


function capitalizeFirstLetter(string) {
  if (string === undefined) {
    return ""
  }
  return string.charAt(0).toUpperCase() + string.slice(1);
}



export default observer(
  class extends React.Component {
    componentDidMount() {
      window.$(".splash").slimscroll({
        height: "calc(100vh - 40px)",
        width: "100%",
      });
    }

    render() {
      return (
        <div>
          <div className="splash">
            <div className="the-inner-right-section">
              <div id="front-screen">
                <h1 className="welcome-page-title add-cloud-computer-message building-process-message">
                  Get Started!
                </h1>
                <p className="welcome-message building-process-message tutorials-page">
                  Click below to get connected
                </p>

                {loading.get() ? (
                  <LoadingScreen />
                ) : (
                  getSplashVMs().map(
                    ({ descriptor: vm_description, id, is_vmpool, state }) =>
                      // Only display VM category if there exists a permission

                      !displayPermissionsForVM(id, is_vmpool).length ? null : (
                        <div key={id} className="container main-page-display" style={{ position: 'relative' }}>
                          <>
                            {!is_vmpool && (() => {
                              const full = vms_list_original.get().find((v) => v.id === id);
                              if (!full || !full.base_proxy_url) return null;
                              const latencyVm = {
                                id,
                                state: state || full.state || '',
                                regionName: full.region?.name ?? '',
                                regionDisplay: full.region?.display ?? '',
                                baseProxyUrl: full.base_proxy_url,
                              };
                              return (
                                <div className="connection-container">
                                  <span>Connection Status:</span>
                                  <Latency vm={latencyVm} onContactSupportClick={openZendeskChat} />
                                </div>
                              );
                            })()}
                            <div className="main-wraper-vm-name">
                              <div className="vm-name-new">
                                <span className="vm-name">
                                  <i
                                    className={
                                      is_vmpool ? "fa fa-sitemap" : "fa fa-desktop"
                                    }
                                    aria-hidden="true"
                                    style={{ padding: 0 }}
                                  ></i>
                                  <span style={{ marginLeft: 10 }}>
                                    {vm_description}
                                  </span>
                                  {vms_list_original.get().length !== 0 &&
                                    <div style={{ marginTop: '-5px' }}>
                                      <VMStatus state={state} id={id} style={{ marginLeft: '5px', marginRight: '5px', fontSize: '13px', }} />

                                        <span style={{fontSize: '13px', color: '#888888'}}>
                                          {capitalizeFirstLetter(state || (vms_list_original.get().find(({id: id_}) => id_ === id) && vms_list_original.get().find(({id: id_}) => id_ === id).state))}
                                        </span>

                                    </div>
                                  }
                                </span>
                              </div>
                            </div>
                            <div className="row text-center">
                              {displayPermissionsForVM(id, is_vmpool).map(
                                ([perm_id, { vm, vmuser, type, app }]) => (
                                  <div
                                    className="col-lg-4 col-md-6"
                                    key={perm_id}
                                  >
                                    <a
                                      href="#."
                                      onClick={(e) => {
                                        e.preventDefault()
                                        open_vm(perm_id)
                                      }}
                                      style={{ cursor: "pointer" }}
                                      className="trigger-sidebar"
                                    >
                                      <div className="card main-page-app">
                                        <div className="card-body card-body-custom">
                                          <div className="image-container-main-page">
                                            <img
                                              className="tw-inline-flex"
                                              src={
                                                type === 'vm' ? "images/desktop-application-icon-v2cloud2.png" : (
                                                  type === 'vmpool' ? "images/desktop-application-icon-v2cloud2-pool.png" : (
                                                    type === 'app' ? "images/computer2.png" : "images/computer2-pool.png"
                                                  )
                                                )
                                              }
                                              style={{width: 66}}
                                              alt=""
                                            />
                                          </div>
                                          <div className="col pc-menus-triggers">
                                            <div className="col pc-menus-triggers">
                                              <span className="pc-name">
                                                {(type === "vm" || type === 'vmpool') ? "Desktop" : ""}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="pc-name">
                                            {(type === "vm" || type === "vmpool")
                                              ? vms_list.get()[vm.id].descriptor
                                              : app.display_name}
                                          </div>
                                        </div>
                                      </div>
                                    </a>
                                  </div>
                                )
                              )}
                            </div>
                          </>
                        </div>
                      )
                  )
                )}

                {
                  //   !loading.get() && permission_list.get().filter(perm => ).map()
                }

              </div>
            </div>
          </div>
        </div>
      );
    }
  }
);
